export default "__VITE_ASSET__dbfe954e__"